import classNames from 'classnames';
import React from 'react';
import EfImgVideo from '../ef-img-video';
import './index.scss';
import EfLink from '../ef-link';

export interface EfCardsAItemProps {
    /**
     * 图片链接是否是视频
     */
    isVideo?: boolean;
    /**
     * 所有分辨率展示的资源链接
     */
    pc?: string;
    /**
     * 分辨率小于等于1024px展示的资源链接
     */
    h5?: string;
    /**
     * 视频贴图-所有分辨率
     */
    poster?: string;
    /**
     * 视频贴图-分辨率小于等于1024px
     */
    posterH5?: string;
    /**
     * 主标题
     */
    title?: string;
    /**
     * 描述
     */
    desc?: string;
    /**
     * 链接文字
     */
    link?: string;
    /**
     * 链接
     */
    href?: string;
}
interface EfCardsAProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 列表
     */
    list: EfCardsAItemProps[];
}

/**
 * 维护:谢保林
 *
 * 卡片列表
 */
const EfCardsA: React.FC<EfCardsAProps> = ({ list, className }) => {
    const prefixCls = `ef-cards-a`;
    const classes = classNames(prefixCls, 'ef-container', {
        [`${className}`]: className,
    });

    return (
        <div className={classes}>
            {list?.map((item: EfCardsAItemProps, index: number) => {
                return (
                    <div key={index} className={`${prefixCls}-item`}>
                        <div className={`${prefixCls}-item-img`}>
                            <EfImgVideo
                                isVideo={item.isVideo}
                                pc={item.pc}
                                h5={item.h5}
                                poster={item.poster}
                                posterH5={item.posterH5}
                                autoPlay={true}
                                loop={true}
                            />
                        </div>
                        <div className={`${prefixCls}-item-msg`}>
                            {item.title && <div className={`${prefixCls}-item-title`}>{item.title}</div>}
                            {item.desc && <div className={`${prefixCls}-item-desc`}>{item.desc}</div>}
                            {item.link && (
                                <EfLink
                                    className={`${prefixCls}-item-link`}
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'select_news',
                                        title_name: item.title,
                                        button_name: item.link,
                                    }}
                                    href={item.href}
                                >
                                    {item.link}
                                </EfLink>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default EfCardsA;
